import { RestSlice } from '../../../../redux/rest.slice';
import { IppReportPackage } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippScheduledReportsSlice = new RestSlice<IppReportPackage>(
	localizationService.getLocalizedString('ipp.reportPackage.package.reportTypes.Scheduled'),
	Resource.IppScheduledReports
);
export default ippScheduledReportsSlice.rests.reducer;
